import {
  CREATED_FILTER_NAME,
  DUE_DATE_FILTER_NAME,
  PRIVATE_UPDATED_FILTER_NAME,
} from '../../constants/filter'

import { DashboardSeverity } from './DashboardBirdview.constants'

export const BIRDVIEW_ATTENTION_NO_ACTIVITY_HOURS = 48

export const BirdviewAttentionGroup = {
  AwaitingProvider: 'awaitingProvider',
  DueToday: 'dueToday',
  InProgress: 'inProgress',
  NoActivity: 'noActivity',
  Overdue: 'overdue',
  Pending: 'pending',
  Unassigned: 'unassigned',
}

export const BirdviewAttentionAge = {
  All: 'all',
  Days7To14: '7-14',
  Days14To30: '14-30',
  Days30To90: '30-90',
  Days90Plus: '90+',
}

export const BIRDVIEW_ATTENTION_AGE_OPTIONS = [
  {
    labelKey: 'DashboardBirdview.AttentionAgeAllOptionKey',
    value: BirdviewAttentionAge.All,
  },
  {
    labelKey: 'DashboardBirdview.AttentionAgeRangeOptionKey',
    maxDays: 14,
    minDays: 7,
    value: BirdviewAttentionAge.Days7To14,
  },
  {
    labelKey: 'DashboardBirdview.AttentionAgeRangeOptionKey',
    maxDays: 30,
    minDays: 14,
    value: BirdviewAttentionAge.Days14To30,
  },
  {
    labelKey: 'DashboardBirdview.AttentionAgeRangeOptionKey',
    maxDays: 90,
    minDays: 30,
    value: BirdviewAttentionAge.Days30To90,
  },
  {
    labelKey: 'DashboardBirdview.AttentionAgeFromOptionKey',
    minDays: 90,
    value: BirdviewAttentionAge.Days90Plus,
  },
]

export const BIRDVIEW_ATTENTION_DEFAULT_AGE = BIRDVIEW_ATTENTION_AGE_OPTIONS[0]

export const BIRDVIEW_ATTENTION_GROUPS = [
  {
    ageField: CREATED_FILTER_NAME,
    isOpenByDefault: true,
    key: BirdviewAttentionGroup.DueToday,
    labelKey: 'DashboardBirdview.AttentionDueTodayGroupKey',
    tone: DashboardSeverity.Info,
  },
  {
    ageField: DUE_DATE_FILTER_NAME,
    key: BirdviewAttentionGroup.Overdue,
    labelKey: 'DashboardBirdview.TileOverdueKey',
    tone: DashboardSeverity.Error,
  },
  {
    ageField: CREATED_FILTER_NAME,
    key: BirdviewAttentionGroup.Pending,
    labelKey: 'DashboardBirdview.AttentionPendingGroupKey',
    tone: DashboardSeverity.Error,
  },
  {
    ageField: CREATED_FILTER_NAME,
    key: BirdviewAttentionGroup.InProgress,
    labelKey: 'DashboardBirdview.AttentionInProgressGroupKey',
    tone: DashboardSeverity.InProgress,
  },
  {
    ageField: CREATED_FILTER_NAME,
    key: BirdviewAttentionGroup.Unassigned,
    labelKey: 'DashboardBirdview.TileUnassignedKey',
    tone: DashboardSeverity.Error,
  },
  {
    ageField: PRIVATE_UPDATED_FILTER_NAME,
    key: BirdviewAttentionGroup.NoActivity,
    labelKey: 'DashboardBirdview.AttentionNoActivityGroupKey',
    tone: DashboardSeverity.Warning,
  },
  {
    ageField: CREATED_FILTER_NAME,
    key: BirdviewAttentionGroup.AwaitingProvider,
    labelKey: 'DashboardBirdview.AttentionAwaitingProviderGroupKey',
    tone: DashboardSeverity.Warning,
  },
]
